module.exports = __webpack_public_path__ + "static/img/price-icons-rate-active.a643721.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welfare/price-icons-rate-active.png
// module id = 2UP4
// module chunks = 216